import { ReactNode, ComponentType } from 'react';
import cn from 'classnames';

import Title from '@/creditflowresearch/ui/common/components/Title';
import styles from '@/creditflowresearch/ui/common/components/Title/styles.module.scss';
import headerStyles from '@/creditflowresearch/ui/common/components/header/Header/header.module.scss';

interface IBetaTitleProps {
  title: string,
  showBeta?: boolean,
  TextWrapper?: ComponentType<{ className?: string, children: ReactNode }>,
  className?: string,
  titleClassName?: string,
  betaClassName?: string,
  children?: ReactNode,
}

const BetaTitle = ({
  title,
  showBeta = false,
  TextWrapper,
  className,
  titleClassName,
  betaClassName,
  children,
}: IBetaTitleProps) => {
  const WrapperComponent = TextWrapper || Title;

  return (
    <div className={ cn(styles.betaTitle, className) }>
      <WrapperComponent className={ cn(styles.title, titleClassName) }>
        <span>
          { title }
          { showBeta && (
            <span className={ cn(headerStyles.beta, styles.beta, betaClassName) }>
              (Beta)
            </span>
          ) }
        </span>
      </WrapperComponent>
      { children }
    </div>
  );
};

export default BetaTitle;
